import Nav, { shellStyles as s } from './Nav';

interface LayoutProps {
  children: React.ReactNode;
  maxWidth?: 'dash' | 'form';
}

export default function Layout({ children, maxWidth = 'dash' }: LayoutProps) {
  return (
    <div className={s.shell}>
      <Nav />
      <div className={s.content}>
        <main className={`${s.main} page-body`} id="main-content">
          <div className={`container${maxWidth === 'form' ? ' container--form' : ''}`}>
            {children}
          </div>
        </main>
        <footer className={s.footer}>
          <span className={s.footerText}>© 2026 Dragnet Solutions Limited. Internal Use Only.</span>
        </footer>
      </div>
    </div>
  );
}
